import { Button, Modal, notification, Space, Table, Tag, Typography } from "antd"
import { useEffect } from "react"
import { useState } from "react"
import { deleteModule, getModules } from "../../data"
import { CloseCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";

const { Title } = Typography
function Modules() {

    const [dataSource, setDataSource] = useState([])
    const [forceRefresh, setForceRefresh] = useState(true)
    const [showModal, setShowModal] = useState(false)

    let history = useHistory()

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            render: (is_active) => <Tag color={is_active ? 'green' : 'red'}>{is_active ? 'Active' : 'Inactive'}</Tag>
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => {
                return (
                    <Space size='small'>
                        <Button onClick={() => history.push({ pathname: '/modules/form/' + record.id })}>Edit</Button>
                        <Button onClick={() => openDeleteModal(record.id)}>Delete</Button>
                    </Space>)
            }
        },
    ]

    const openDeleteModal = (id) => {
        localStorage.setItem('module', id);
        setShowModal(true)
    }

    const deleteRow = async () => {
        let module_id = localStorage.getItem('module')
        const data = await deleteModule(module_id);

        if (data) {
            setShowModal(false)
            setForceRefresh(true)
            notification.open({ message: 'Module has been deleted successfully', icon: <DeleteOutlined style={{ color: '#108ee9' }} /> })
        } else {
            notification.open({ message: 'Unable to deleted module', icon: <CloseCircleOutlined style={{ color: 'red' }} /> })
        }
    }

    const initialize = async () => {
        const response = await getModules(forceRefresh)
        setDataSource(response)
        setForceRefresh(false)
    }

    useEffect(() => {
        initialize();
    }, [])

    useEffect(() => {
        if (forceRefresh) {
            initialize();
        }
    }, [forceRefresh])

    const renderHeader = () => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Title level={3}>Modules</Title>
                    <Space size="small" >
                        <Button type="primary" onClick={() => history.push({ pathname: '/modules/form/0' })}>Add Module</Button>
                    </Space>
                </div>
            </>
        )
    }
    return (
        <>
            <Table
                dataSource={dataSource}
                columns={columns}
                title={() => renderHeader()}
            />

            <Modal
                title="Delete Module"
                centered
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={[
                    <Button key="delete" onClick={() => deleteRow()}>
                        Delete
                    </Button>,
                    <Button key="back" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                ]}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p>Are you sure you want to delete this module?</p>
                </div>
            </Modal>
        </>
    )

}
export default Modules
